import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Scale } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function TermsOfService() {
    return (
        <div className="relative min-h-screen bg-[#050510] text-gray-300 py-24 px-6 md:px-12 font-sans font-medium">
            <div className="fixed inset-0 pointer-events-none opacity-20" style={{ backgroundImage: 'radial-gradient(circle, #ffffff 1px, transparent 1px)', backgroundSize: '40px 40px' }} />

            <div className="max-w-3xl mx-auto relative z-10">
                <Link to="/" className="inline-flex items-center gap-2 text-gray-400 hover:text-white mb-12 transition-colors">
                    <ArrowLeft className="w-4 h-4" />
                    Back to Home
                </Link>

                <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
                    <div className="flex items-center gap-4 mb-8">
                        <div className="w-12 h-12 bg-[#FF7A00]/10 border border-[#FF7A00]/20 rounded-xl flex items-center justify-center">
                            <Scale className="w-6 h-6 text-[#FF7A00]" />
                        </div>
                        <h1 className="text-4xl font-bold tracking-tight text-white">Terms of Service</h1>
                    </div>

                    <div className="prose prose-invert max-w-none space-y-6">
                        <p className="text-lg leading-relaxed text-gray-400">
                            Effective Date: January 1, 2024
                        </p>

                        <div className="bg-white/5 border border-white/10 p-6 md:p-10 rounded-3xl space-y-8">
                            <section>
                                <h2 className="text-xl font-bold text-white mb-3 flex items-center gap-2"><div className="w-1.5 h-1.5 bg-[#4D4DFF] rounded-full" /> 1. Acceptance of Terms</h2>
                                <p className="leading-relaxed text-gray-400 text-sm">
                                    By accessing or using Curezy AI ("The Platform"), you agree to be bound by these Terms of Service. If you disagree with any part of the terms, you may not access the Service.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-white mb-3 flex items-center gap-2"><div className="w-1.5 h-1.5 bg-[#4D4DFF] rounded-full" /> 2. Description of Service</h2>
                                <p className="leading-relaxed text-gray-400 text-sm">
                                    Curezy AI provides a multi-agent artificial intelligence platform intended solely for informational purposes and peer-review simulation for medical professionals. The Service entails software interfaces, ML models, and APIs designed to evaluate symptom clusters.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-white mb-3 flex items-center gap-2"><div className="w-1.5 h-1.5 bg-[#4D4DFF] rounded-full" /> 3. User Responsibilities & Conduct</h2>
                                <p className="leading-relaxed text-gray-400 text-sm">
                                    You are responsible for safely evaluating any content generated by the Service. You agree not to use the Service:
                                    <ul className="list-disc ml-5 mt-2 space-y-1">
                                        <li>To purposefully generate harmful or misleading medical guidance.</li>
                                        <li>To replace the diagnosis of a certified medical professional.</li>
                                        <li>To reverse engineer or attempt to extract the source code of the proprietary AI Council models.</li>
                                    </ul>
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-white mb-3 flex items-center gap-2"><div className="w-1.5 h-1.5 bg-[#4D4DFF] rounded-full" /> 4. Limitations of Liability</h2>
                                <p className="leading-relaxed text-gray-400 text-sm">
                                    In no event shall Curezy AI, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of or inability to access or use the Service.
                                </p>
                            </section>
                        </div>
                    </div>
                </motion.div>
            </div>
        </div>
    );
}
